import React from "react";

const PromoBanner = () => {
  // Hide on the ebook page itself
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/ebook")) return null;

  return (
    <div style={{
      position: "sticky", top: 0, zIndex: 9999,
      background: "#1C4C3F", color: "#fff", textAlign: "center",
      padding: "10px 12px", boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
      fontWeight: 500, fontSize: 14, lineHeight: 1.2
    }}>
      <a
        href="/ebook?utm_source=shelfkey&utm_medium=banner&utm_campaign=ebook"
        style={{ color: "#fff", textDecoration: "none", display: "inline-flex", gap: 8, alignItems: "center" }}
      >
        New: CPG Founder Playbook — get the eBook for $5.99 →
      </a>
    </div>
  );
};

export default PromoBanner;
